import React, { useEffect } from 'react';

export type UseListColumnsOptions = {
  initialValue?: number;
  minColumnWidth?: number;
};

const getColumns = (width: number, minColumnWidth?: number) => {
  if (minColumnWidth) {
    return Math.max(1, Math.floor(width / minColumnWidth));
  }
  return width > 800 ? 4 : width > 600 ? 3 : 2;
};

export const useListColumns = (
  ref: React.RefObject<HTMLElement>,
  { initialValue = 2, minColumnWidth }: UseListColumnsOptions = {},
) => {
  const [listColumns, setListColumns] = React.useState(initialValue);

  useEffect(() => {
    const container = ref.current;
    if (!container) {
      return;
    }

    const resizeObserver = new ResizeObserver((entries) =>
      entries.forEach((entry) =>
        setListColumns(getColumns(entry.contentRect.width, minColumnWidth)),
      ),
    );
    resizeObserver.observe(container);

    setListColumns(getColumns(container.clientWidth, minColumnWidth));

    return () => resizeObserver.unobserve(container);
  }, [ref, minColumnWidth]);

  return listColumns;
};
